(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pc-dark-edit"]) return;
  try {
    
document.addEventListener('click', function(event) {
  const button = event.target.closest('.pc-ticker-toggle');
  if (!button) return;
  const paused = button.getAttribute('aria-pressed') !== 'true';
  button.setAttribute('aria-pressed', String(paused));
  button.setAttribute('aria-label', paused ? 'Play ticker' : 'Pause ticker');
  button.querySelector('span').textContent = paused ? '▷' : 'Ⅱ';
  button.closest('.pc-runner-ticker').dataset.paused = String(paused);
});

  } catch(e) { console.error(e); }
})();
})();
